import {
  filterByCellValueMenuItem,
  HamburgerMenu,
  useDynamicCallback,
  useJsonModal,
  useMixpanel,
  type AgGridMenuItems,
  type Column,
  type ColumnDef,
  type FilterableProperty,
  type MarketTrade,
  type UseFilterBuilderOutput,
} from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-enterprise';
import { compact, isNil } from 'lodash-es';
import { useMemo, type ReactNode } from 'react';
import { colIDToFilterBuilderKey } from './useMarketTradeFilter';

export function useMarketTradeMenu({
  openClause,
  filterableProperties,
}: {
  openClause: UseFilterBuilderOutput['addAndOpenClause'];
  filterableProperties: FilterableProperty<string>[];
}): {
  columns: Column[];
  getCustomContextMenuItems: (params: GetContextMenuItemsParams) => AgGridMenuItems;
  dialogs: ReactNode;
} {
  const mixpanel = useMixpanel();
  const { handleClickJson, jsonModal } = useJsonModal();

  const getCustomContextMenuItems = useDynamicCallback((params: GetContextMenuItemsParams) => {
    const data = params?.node?.data;
    const groupData = params?.node?.groupData;
    if (isNil(data) && isNil(groupData)) {
      return [];
    }

    return filterByCellValueMenuItem({
      params,
      filterableProperties,
      openClause,
      colIDToFilterBuilderKey,
      mixpanel,
    });
  });

  const dialogs = useMemo(() => <>{jsonModal}</>, [jsonModal]);

  const columns = useMemo(
    () =>
      compact([
        {
          type: 'hamburgerMenu',
          id: 'rowMenu',
          params: {
            renderItems: params => <HamburgerMenu {...params} onShowJson={handleClickJson} />,
          },
        },
      ] satisfies ColumnDef<MarketTrade>[]),
    [handleClickJson]
  );

  return {
    columns,
    getCustomContextMenuItems,
    dialogs,
  };
}
